import React, { memo, ChangeEvent } from 'react'
import {
  ISpotBiddingRule,
  IRuleStartTimeCriteria,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TIME_INPUT_FORMAT, TimeInput } from 'transfix-ui'

interface IRuleStartTimeProps {
  value?: RecursivePartial<IRuleStartTimeCriteria>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const RuleStartTime = memo<IRuleStartTimeProps>(
  ({ onChange, value: ruleStartTimeCriteria }) => {
    const { rangeStart = '' } = ruleStartTimeCriteria || {}

    const changeTimeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      onChange({
        ruleStartTimeCriteria: {
          ...ruleStartTimeCriteria,
          rangeStart: value,
        },
      })
    }

    return (
      <TimeInput
        label='Rule Start Time (EST)'
        placeholder='Optional'
        value={rangeStart}
        onChange={changeTimeHandler}
        large
        timeFormat={TIME_INPUT_FORMAT.MILITARY}
      />
    )
  }
)
